import { Dispatch, createContext } from "react";
export type ConfigType = {
  cashPickUpBanks: any[];
  telcos: any[];
  sourceOfIncome: any[];
  purposeOfTransfer: any[];
};

interface IContext {
  config: ConfigType;
  configDispatch: Dispatch<any>;
}

const ConfigContext = createContext({} as IContext);

export default ConfigContext;
